/* eslint-disable jsx-a11y/control-has-associated-label */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Col, Row } from '@thd-olt-component-react/grid';
import { Button } from '@thd-olt-component-react/button';
import { StandardDimension } from '../Dimensions/StandardDimension';
import { VisualDimension } from '../Dimensions/VisualDimension';
import { shouldRenderVisualRefinement } from '../../product-results-helpers';

class TopFilters extends Component {

  constructor(props) {
    super(props);
    this.state = {
      collapsed: true,
      currentDimension: null
    };
  }

  componentDidMount() {
    window.addEventListener('popstate', this.onPopstate);
  }

  componentWillUnmount() {
    window.removeEventListener('popstate', this.onPopstate);
  }

  getRefinementId = (refinement, refinementIndex) => {
    const { refinementKey } = refinement;
    return `${refinementKey}-${refinementIndex}`;
  };

  handleSeeAll = (event) => {
    event.preventDefault();
    this.setState((prevState) => ({
      collapsed: !prevState.collapsed
    }));
  };

  onRefinementChange = (args) => {
    const { onChange } = this.props;
    this.setState({ currentDimension: null });
    onChange({ ...args });
  };

  getDimension = () => {
    const { dimensions = [] } = this.props;
    const { currentDimension } = this.state;

    if (!currentDimension) {
      return null;
    }

    const dimension = dimensions.find((dim) => dim.label === currentDimension.label);
    if (!dimension) {
      return null;
    }

    const { refinements } = dimension;

    const {
      enableMultiStore,
      onMultiStoreSelectionChange,
      multiStoreSelection,
      enableVisualRefinement
    } = this.props;

    if (enableVisualRefinement && dimension.label.toUpperCase() === 'STYLE') {
      if (shouldRenderVisualRefinement(refinements)) {
        return (
          <VisualDimension
            mini
            key={dimension.dimensionId}
            onChange={this.onRefinementChange}
            dimension={dimension}
          />
        );
      }
    }

    return (
      <Row className="top-filters__dimension">
        <StandardDimension
          key={dimension.dimensionId}
          dimension={dimension}
          onChange={this.onRefinementChange}
          mini
          enableMultiStore={enableMultiStore}
          onMultiStoreSelectionChange={onMultiStoreSelectionChange}
          multiStoreSelection={multiStoreSelection}
        />
        <button
          type="button"
          className="top-filters__dimension__edge"
          onClick={this.closeDrawer}
        />
      </Row>
    );
  };

  openDrawer = (dim) => {
    this.setState({ currentDimension: dim });
  };

  closeDrawer = () => {
    this.setState({ currentDimension: null });
  };

  handleToggleDrawer = () => {
    const { toggleDrawer } = this.props;
    if (toggleDrawer) {
      toggleDrawer();
    }
  };

  onPopstate = () => {
    const { handleCloseDrawer, isOpen } = this.props;
    if (isOpen) handleCloseDrawer();
  };

  openLabel = (event, { dimensions, label }) => {
    event.preventDefault();
    this.setState({ collapsed: true });
    const { currentDimension } = this.state;
    if (label === 'Filter & Sort') {
      if (typeof window !== 'undefined') {
        window.history.pushState({ page: 'FILTER_SORT_DRAWER', scrollY: window.scrollY }, null, '');
      }
      this.handleToggleDrawer();
    } else if (currentDimension && currentDimension.label === label) {
      this.closeDrawer();
    } else {
      const dim = dimensions.find((dimension) => dimension.label === label);
      this.openDrawer(dim);
    }
  };

  getTopDimensions = () => {
    const { dimensions = [], suppressFilter } = this.props;
    let topDimensions = dimensions
      .filter((dimension) => dimension.isVisualNav)
      .filter((dimension) => suppressFilter.indexOf(dimension.label.toUpperCase()) === -1)
      .sort((dim1, dim2) => dim1.visualNavSequence - dim2.visualNavSequence);
    return topDimensions.length > 0 ? topDimensions : null;
  };

  getLabelByDimension = ({ dimensionId, label }) => {
    const { currentDimension } = this.state;
    const { dimensions = [] } = this.props;
    const sortFilter = { dimensionId: 'sort-filter', label: 'Filter & Sort' };
    const colClassName = classNames('top-filters__col', {
      'top-filters__col--bold': (currentDimension && label === currentDimension.label),
    });
    const caretClassName = classNames('top-filters__caret ', {
      'top-filters__caret--open': (currentDimension && label === currentDimension.label),
    });
    const linkClassName = classNames('top-filters__link', {
      'top-filters__link--blue top-filters__box': label === sortFilter.label
    });

    return (
      <div
        key={dimensionId}
        className={colClassName}
      >
        <Button
          className={linkClassName}
          link
          tag="a"
          onClick={(event) => this.openLabel(event, { label, dimensions })}
        >
          <span className="top-filters__label">
            {dimensionId === sortFilter.dimensionId ? sortFilter.label : label}
          </span>
          {dimensionId !== sortFilter.dimensionId
            && (
              <img
                alt="open arrow"
                className={caretClassName}
                src="https://assets.homedepot-static.com/images/v1/caret-orange.svg"
              />
            )}
        </Button>
      </div>
    );
  }

  getLabels = ({ filterDimensions = [] }) => {
    const sortFilter = { dimensionId: 'sort-filter', label: 'Filter & Sort' };
    if (filterDimensions && filterDimensions.length) {
      filterDimensions.unshift(sortFilter);
      let topFilters = filterDimensions;
      const getItFastDimension = filterDimensions.find((dim) => dim.label === 'Get It Fast');
      if (getItFastDimension) {
        topFilters = filterDimensions.filter((dimension) => dimension.label !== 'Get It Fast');
        topFilters.push(getItFastDimension);
      }
      return (
        <div className="top-filters__labels-container">
          {
            topFilters.map((dimension) => {
              return this.getLabelByDimension(dimension);
            })
          }
        </div>
      );
    }
    const sortFilterClasses = classNames(
      'top-filters__link',
      'top-filters__link--blue',
      'top-filters__box'
    );

    return (
      <div className="top-filters__col">
        <Button
          className={sortFilterClasses}
          link
          tag="a"
          onClick={(event) => this.openLabel(event, sortFilter)}
        >
          <span className="top-filters__label">
            {sortFilter.label}
          </span>
        </Button>
      </div>
    );
  };

  render() {
    const {
      dimensions,
      maxDimension
    } = this.props;
    let filterDimensions = [];
    if (dimensions.length === 0) return null;
    let topDimensions = this.getTopDimensions();
    if (topDimensions && topDimensions.length) {
      filterDimensions = topDimensions.slice(0, maxDimension);
    }
    return (
      <div className="grid top-filters__wrapper">
        <Col className="top-filters--background">
          {this.getLabels({ filterDimensions })}
        </Col>
        <Row>
          {this.getDimension()}
        </Row>
      </div>
    );
  }
}

TopFilters.propTypes = {
  suppressFilter: PropTypes.arrayOf(PropTypes.string),
  dimensions: PropTypes.arrayOf(
    PropTypes.shape({})
  ).isRequired,
  maxDimension: PropTypes.number,
  onChange: PropTypes.func.isRequired,
  toggleDrawer: PropTypes.func.isRequired,
  handleCloseDrawer: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  enableMultiStore: PropTypes.bool,
  multiStoreSelection: PropTypes.string,
  onMultiStoreSelectionChange: PropTypes.func,
  enableVisualRefinement: PropTypes.bool
};

TopFilters.defaultProps = {
  suppressFilter: [],
  maxDimension: 0,
  enableMultiStore: false,
  multiStoreSelection: null,
  onMultiStoreSelectionChange: null,
  enableVisualRefinement: false
};

export {
  TopFilters
};
